import {
  ITennisLiveScore,
  TennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { useIntcmp } from '../../hooks/useIntcmp';

import { log } from "../../utils/log";
import { transformQuery } from "./transformQuery";
import { LiveScoreData } from "./types";
import { useSubscription } from "../../hooks/useSubscription";
import { LiveScoreSubscriptionData } from "./types";
import { transformSubscription } from "./transformSubscription";
import { graphql } from "appsync";
import { WidgetContext } from "../../types/WidgetContext";

export const setCustomAttributes = ({variables}: WidgetContext<LiveScoreData>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql("subscription SdapiLiveScoreSubcription {\n  onUpdateSdapiLiveScoreById(id: \"unique\") {\n    id\n    liveTournaments {\n      competitionId\n      seasonId\n      categoryName\n      circuitType\n      tournamentName\n      tournamentType\n      resultsUrl\n      matches {\n        status\n        startDate\n        roundName\n        resultType\n        firstPosition {\n          isServing\n          players {\n            name\n            nationality\n            seed\n          }\n          score {\n            isWinner\n            set\n            tie\n          }\n        }\n        secondPosition {\n          isServing\n          players {\n            name\n            nationality\n            seed\n          }\n          score {\n            isWinner\n            set\n            tie\n          }\n        }\n      }\n    }\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<LiveScoreData>): ITennisLiveScore {
  return transformQuery(props);
}

const LiveScore = ({props,
  variables,
  ...rest
}: WidgetContext<ITennisLiveScore>) => {
  log({ props, variables, ...rest });
  const intCmpEventHandler = useIntcmp();

  const updatedProps = useSubscription<
    ITennisLiveScore,
    LiveScoreSubscriptionData,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: true,
  }) as ITennisLiveScore;
  
  return (
    <div onClick={intCmpEventHandler}>
      <TennisLiveScore {...updatedProps}/>
    </div>
  );
}

export default LiveScore;